import { buildMsoConfigQuery } from '../utils/query';

export const getMsoConfigRequest = buildMsoConfigQuery((props) => ({
  transform: (msoConfig) => ({ msoConfig }),
  update: {
    msoConfig: (prev, updated) => updated,
  },
}))
